import { RendererService } from './../renderer.service';
import { Component } from '@angular/core';
import { CubeModel } from '../../model';
import { EntityComponent } from '../share/entity-component';
import { Mesh, CubeGeometry, MeshBasicMaterial, Vector3 } from 'three';
import { SceneService } from '../scene.service';

@Component({
  selector: 'ng3-cube',
  templateUrl: './cube.component.html',
  styleUrls: ['./cube.component.css'],
})
export class CubeComponent extends EntityComponent<CubeModel> {
  rotationSpeed = 0.02;
  bouncingSpeed = 0.03;
  // gui: GUI = new GUI();

  constructor(
    sceneService: SceneService,
    renderer: RendererService,
  ) {
    super(sceneService, renderer);
  }
  createEntity(model: CubeModel) {
    const result = new Mesh(
      new CubeGeometry(1, 1, 1),
      new MeshBasicMaterial({
        color: 0xff0000,
        transparent: true,
        opacity: 0.5,
        wireframe: true,
      }),
    );
    result.name = 'Cube';
    result.position.copy(model.center);
    result.scale.copy(model.size);
    result.rotation.x = Math.PI / 4;
    result.rotation.y = Math.PI / 4;
    result.rotation.z = Math.PI / 4;
    return result;
  }
  updateEntity(model: CubeModel, entity: Mesh) {
    // this.gui.add(this.rotationSpeed, 'rotationSpeed', 0, 0.5);
    entity.position.copy(model.center);
    entity.scale.copy(model.size);
    return entity;
  }
  defaultModel() {
    return new CubeModel(
      new Vector3(100, 100, 100),
      new Vector3(0, 0, 0),
      new Vector3(0, 0, 0),
    );
  }
}
